<template>
  <b-modal
    :id="id"
    :ref="`${id}-modal`"
    v-model="shown"
    :size="modalOptions.size"
    :scrollable="true"
    :centered="true"
    :hide-header="false"
    :hide-footer="true"
    :no-close-on-backdrop="modalOptions.noCloseOnBackdrop"
    :no-close-on-est="modalOptions.noCloseOnEsc"
    @show="beforeShown"
    @shown="onShown"
    @hide="beforeHidden"
    @hidden="onHidden"
  >
    <template v-slot:modal-title>
      <slot name="modal-title">
        {{ title }}
      </slot>
    </template>
    <div :data-cy="`${id}-modal`">
      <slot />
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    opened: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      state: '',
      shown: false,
      deleteModal: false,
      disableModal: false,
      defaultOptions: {
        // height: 'auto',
        // width: 600,
        size: 'xl',
        noCloseOnBackdrop: false,
        noCloseOnEst: false,
      },
    };
  },

  computed: {
    modalOptions() {
      const modalOptions = { ...this.defaultOptions, ...this.options };
      // console.log(`${this.id} modal options`, modalOptions);
      return modalOptions;
    },
  },

  mounted() {
    Bus.$on('modals:hide-all', () => {
      // console.log('hiding all modals');
      if (this.shown) {
        // console.log(`hiding modal ${this.id}`);
        this.shown = false;
      }
    });

    // Bus.$on('modal:toggle', (modalId) => {
    //   console.log('modal:toggle', modalId);

    //   if (this.id === modalId) {
    //     this.shown = !this.shown;
    //   }
    // });

    this.shown = this.opened;
  },

  beforeDestroy() {
    Bus.$off('modals:hide-all');
    // Bus.$off('modal:toggle');
  },

  methods: {
    beforeShown() {
      this.registerBusListeners();
    },

    beforeHidden() {
      Bus.$emit('modal:set-model-id', this.id, 0);
      this.unregisterBusListeners();
    },

    onShown() {
      this.$emit('opened');
      this.shown = true;
    },

    onHidden() {
      this.$emit('closed');
      this.shown = false;
    },

    registerBusListeners() {
      Bus.$on('modal_scroll_to_top', () => {
        if (this.shown) {
          this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
        }
      });
    },

    unregisterBusListeners() {
      Bus.$off('modal_scroll_to_top');
    },
  },
};
</script>

<style>
/* .modal .modal-body { */
/* padding: 10px; */
/* } */

@screen lg {
  .modal .modal-xl {
    /* max-width: 95vw; */
  }
}
@screen xl {
  .modal .modal-xl {
    /* max-width: 95vw; */
  }
}
</style>
